import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MBRModal from '../../../common/components/MBRModal';
import EnquireForm from './parts/EnquireForm';
import EnquireInfo from './parts/EnquireInfo';
import { form } from './constants';

export default class EnquireModal extends PureComponent {
  static propTypes = {
    modal: PropTypes.shape({}).isRequired,
    toggleModal: PropTypes.func.isRequired,
    enquire: PropTypes.func.isRequired,
    setSubmitted: PropTypes.func.isRequired,
  };

  handleClose = () => {
    this.props.toggleModal(false);
    this.props.setSubmitted(false);
  };

  handleSubmit = (values, form) => {
    this.props.enquire({ values, form });
  };

  render() {
    const {
      modal: { visible, submitted },
    } = this.props;
    return (
      <MBRModal visible={visible}>
        {!submitted && (
          <EnquireForm form={form} onCancel={this.handleClose} onSubmit={this.handleSubmit} />
        )}
        {submitted && <EnquireInfo onClose={this.handleClose} />}
      </MBRModal>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/EnquireModal.js